import { css } from '@emotion/react';
import styled from '@emotion/styled';
import React, { FC } from 'react';
import { Caution } from '../../icons';
import { Typography } from '../../Typography';
import { createMarkup }  from '../../../utils/createMarkup';

export interface FormErrorProps {
  message: string | undefined;
  inline?: boolean;
  display?: boolean;
  errorMessageElementId?: string;
}

const StyledFormError = styled(Typography)<{
  $display?: boolean;
  inline: boolean;
}>`
  ${({ theme: { space, colors }, inline, $display }) => css`
    display: ${inline ? 'inline-block' : 'flex'};
    align-items: flex-start;
    gap: 8px;
    color: rgb(201, 44, 54);
    white-space: pre-wrap;
    margin-top: 24px;

    a {
      text-decoration: underline;
    }

    ${!$display &&
    css`
      display: none;
    `}
  `}
`;

const StyledCaution = styled(Caution)`
  ${({ theme: { space } }) => css`
    height: 24px;
    position: relative;
    width: 24px;
  `}
`;

export const FormError: FC<
  React.PropsWithChildren<FormErrorProps> & Partial<HTMLDivElement>
> = ({ message, inline = false, display, errorMessageElementId }) =>
  message &&
  display && (
    <StyledFormError
      variant="paragraph"
      $display={!!(message && display)}
      inline={inline}
      aria-live="assertive"
    >
      {message && display ? (
        <>
          <Typography variant="paragraph" component="span" visuallyHidden>
            Error:
          </Typography>
          <StyledCaution aria-hidden="true" />
          {createMarkup(message)}
        </>
      ) : (
        ''
      )}
    </StyledFormError>
  );
